import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-4 mb-2" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["max"]
const _hoisted_9 = { class: "col-md-8 mb-3" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "col-md-12 m-10" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "border border-primary mb-10" }
const _hoisted_14 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_15 = { class: "col-md-5" }
const _hoisted_16 = { class: "d-flex float-end" }
const _hoisted_17 = {
  class: "accordion dark-accordion my-3 py-7",
  id: "magasin"
}
const _hoisted_18 = ["id"]
const _hoisted_19 = ["data-bs-target", "aria-expanded", "aria-controls"]
const _hoisted_20 = ["id", "aria-labelledby"]
const _hoisted_21 = { class: "accordion-body" }
const _hoisted_22 = { class: "row gx-2" }
const _hoisted_23 = { class: "col-md-5 mb-2" }
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_27 = {
  key: 0,
  class: "col-md-3 mb-2"
}
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "input-group" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = {
  class: "input-group-text",
  id: "inputGroup-sizing-default"
}
const _hoisted_32 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_33 = {
  key: 1,
  class: "col-md-3 mb-2"
}
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { class: "input-group" }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = {
  class: "input-group-text",
  id: "inputGroup-sizing-default"
}
const _hoisted_38 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_39 = {
  key: 2,
  class: "col-md-3 mb-2"
}
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = { class: "input-group" }
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = {
  class: "input-group-text",
  id: "inputGroup-sizing-default"
}
const _hoisted_44 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_45 = {
  key: 3,
  class: "col-md-3 mb-2"
}
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = { class: "input-group" }
const _hoisted_48 = ["onUpdate:modelValue"]
const _hoisted_49 = {
  class: "input-group-text",
  id: "inputGroup-sizing-default"
}
const _hoisted_50 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_51 = {
  key: 4,
  class: "col-md-3 mb-2"
}
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = { class: "input-group" }
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = {
  class: "input-group-text",
  id: "inputGroup-sizing-default"
}
const _hoisted_56 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_57 = {
  key: 5,
  class: "col-md-3 mb-2"
}
const _hoisted_58 = { class: "form-group" }
const _hoisted_59 = { class: "input-group" }
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = {
  class: "input-group-text",
  id: "inputGroup-sizing-default"
}
const _hoisted_62 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_63 = { class: "col-md-1 mt-4" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { class: "border border-primary mb-10" }
const _hoisted_66 = { class: "row gx-0 d-flex align-items-center justify-content-between fw-bold p-2 bg-primary" }
const _hoisted_67 = { class: "col-md-5" }
const _hoisted_68 = { class: "d-flex float-end" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "p-3" }
const _hoisted_71 = { class: "row mt-10 gx-1" }
const _hoisted_72 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_73 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_74 = { class: "col-md-3" }
const _hoisted_75 = { class: "form-group mb-2" }
const _hoisted_76 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_77 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_78 = { class: "col-md-2" }
const _hoisted_79 = { class: "form-group mb-2" }
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_82 = { class: "col-md-3" }
const _hoisted_83 = { class: "input-group" }
const _hoisted_84 = ["onUpdate:modelValue"]
const _hoisted_85 = {
  class: "input-group-text",
  id: "inputGroup-sizing-default"
}
const _hoisted_86 = { class: "col-md-3" }
const _hoisted_87 = { class: "form-group mb-2" }
const _hoisted_88 = { class: "input-group" }
const _hoisted_89 = ["onUpdate:modelValue"]
const _hoisted_90 = {
  class: "input-group-text",
  id: "inputGroup-sizing-default"
}
const _hoisted_91 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_92 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_93 = { class: "col-md-1 mb-2" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "col-md-12 mt-3" }
const _hoisted_96 = { class: "d-flex align-items-center" }
const _hoisted_97 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Ajouter un mouvement de fiche")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "mouvementForm",
        onSubmit: _ctx.addMouvement,
        "validation-schema": _ctx.mouvementSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Date Opération "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateOperation) = $event)),
                      name: "dateOperation",
                      type: "datetime-local",
                      max: _ctx.currentDateTime,
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Date oper."
                    }, null, 8, _hoisted_8), [
                      [_vModelText, _ctx.dateOperation]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Bon "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      modelValue: _ctx.ficheProduit,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ficheProduit) = $event)),
                      name: "bonLivre",
                      type: "text"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, {
                          options: _ctx.bonOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                          placeholder: "Sélectionner le bon",
                          onSelect: ($event: any) => (_ctx.selectBon(field.value))
                        }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-md-7" }, [
                      _createElementVNode("h4", { class: "fs-4 text-white" }, "Les mouvements")
                    ], -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btn btn-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addRowMovement()))
                        }, _cache[5] || (_cache[5] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                          _createTextVNode("Ajouter un produit ")
                        ]), 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, produitIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "accordion-item accordion-wrapper",
                          key: produitIndex
                        }, [
                          _createElementVNode("h2", {
                            class: "accordion-header",
                            id: `magasin${produitIndex}`
                          }, [
                            _createElementVNode("button", {
                              class: _normalizeClass(`accordion-button bg-light-primary font-primary ${_ctx.produits.length == produitIndex + 1 ? '' : 'collapsed'}`),
                              type: "button",
                              "data-bs-toggle": "collapse",
                              "data-bs-target": `#collapse${produitIndex}`,
                              "aria-expanded": `${_ctx.produits.length == produitIndex + 1 ? true : false}`,
                              "aria-controls": `collapse${produitIndex}`
                            }, [
                              _createTextVNode(_toDisplayString(produit.nomProd ? produit.nomProd : `Produit ${produitIndex + 1}`) + " ", 1),
                              _cache[7] || (_cache[7] = _createElementVNode("i", {
                                class: "vue-feather vue-feather--chevron-down svg-color",
                                "data-name": "chevron-down",
                                "data-tags": "expand",
                                "data-type": "chevron-down"
                              }, [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "24",
                                  height: "24",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  class: "feather feather-chevron-down vue-feather__content"
                                }, [
                                  _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                                ])
                              ], -1))
                            ], 10, _hoisted_19)
                          ], 8, _hoisted_18),
                          _createElementVNode("div", {
                            class: _normalizeClass(`accordion-collapse collapse ${_ctx.produits.length == produitIndex + 1 ? 'show' : ''}`),
                            id: `collapse${produitIndex}`,
                            "aria-labelledby": `magasin${produitIndex}`,
                            "data-bs-parent": "#magasin"
                          }, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Produit", -1)),
                                    _createVNode(_component_Multiselect, {
                                      modelValue: produit.produit,
                                      "onUpdate:modelValue": ($event: any) => ((produit.produit) = $event),
                                      options: _ctx.produitOptions,
                                      searchable: true,
                                      placeholder: "Sélectionner un produit",
                                      onSelect: ($event: any) => (_ctx.selectProd(produit.produit, produit, produitIndex))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onSelect"]),
                                    (_ctx.validateRowProduit(produit.produit))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Le produit est obligatoire."))
                                      : _createCommentVNode("", true),
                                    (_ctx.validateDupliacatProduit(produit.produit))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Le produit a été déjà sélectionné."))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (parseInt(_ctx.typeBon) === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _createElementVNode("div", _hoisted_28, [
                                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                          _createTextVNode(" Quantité Bon "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_29, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            name: "qteBon",
                                            readonly: "",
                                            "onUpdate:modelValue": ($event: any) => ((produit.qteBon) = $event),
                                            class: _normalizeClass(_ctx.validateRowProduit(produit.qteBon) ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'),
                                            placeholder: "Entrer la quantité"
                                          }, null, 10, _hoisted_30), [
                                            [_vModelText, produit.qteBon]
                                          ]),
                                          _createElementVNode("span", _hoisted_31, _toDisplayString(produit.uniteMesure), 1)
                                        ]),
                                        (_ctx.validateRowProduit(produit.qteBon))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, "La quantité bon est obligatoire."))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(_ctx.typeBon) === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                      _createElementVNode("div", _hoisted_34, [
                                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                          _createTextVNode(" Reste à livrer "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_35, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            name: "resteAliv",
                                            readonly: "",
                                            "onUpdate:modelValue": ($event: any) => ((produit.resteAliv) = $event),
                                            class: _normalizeClass(_ctx.validateRowProduit(produit.resteAliv) ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'),
                                            placeholder: "Entrer la quantité"
                                          }, null, 10, _hoisted_36), [
                                            [_vModelText, produit.resteAliv]
                                          ]),
                                          _createElementVNode("span", _hoisted_37, _toDisplayString(produit.uniteMesure), 1)
                                        ]),
                                        (_ctx.validateRowProduit(produit.resteAliv))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, "Le reste à livrer est obligatoire."))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(_ctx.typeBon) === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      _createElementVNode("div", _hoisted_40, [
                                        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                          _createTextVNode(" Quantité commandée "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_41, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            name: "qteBon",
                                            readonly: "",
                                            "onUpdate:modelValue": ($event: any) => ((produit.qteBon) = $event),
                                            class: _normalizeClass(_ctx.validateRowProduit(produit.qteBon) ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'),
                                            placeholder: "Entrer la quantité"
                                          }, null, 10, _hoisted_42), [
                                            [_vModelText, produit.qteBon]
                                          ]),
                                          _createElementVNode("span", _hoisted_43, _toDisplayString(produit.uniteMesure), 1)
                                        ]),
                                        (_ctx.validateRowProduit(produit.qteBon))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, "La quantité commandée est obligatoire."))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(_ctx.typeBon) === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                      _createElementVNode("div", _hoisted_46, [
                                        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                          _createTextVNode(" Quantité reste à recevoir "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_47, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            name: "resteAliv",
                                            readonly: "",
                                            "onUpdate:modelValue": ($event: any) => ((produit.resteAliv) = $event),
                                            class: _normalizeClass(_ctx.validateRowProduit(produit.resteAliv) ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'),
                                            placeholder: "Entrer la quantité"
                                          }, null, 10, _hoisted_48), [
                                            [_vModelText, produit.resteAliv]
                                          ]),
                                          _createElementVNode("span", _hoisted_49, _toDisplayString(produit.uniteMesure), 1)
                                        ]),
                                        (_ctx.validateRowProduit(produit.resteAliv))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, "La quantité reste à recevoir est obligatoire."))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(_ctx.typeBon) === 2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                      _createElementVNode("div", _hoisted_52, [
                                        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                          _createTextVNode(" Quantité retournée "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_53, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            name: "qteBon",
                                            readonly: "",
                                            "onUpdate:modelValue": ($event: any) => ((produit.qteBon) = $event),
                                            class: _normalizeClass(_ctx.validateRowProduit(produit.qteBon) ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'),
                                            placeholder: "Entrer la quantité"
                                          }, null, 10, _hoisted_54), [
                                            [_vModelText, produit.qteBon]
                                          ]),
                                          _createElementVNode("span", _hoisted_55, _toDisplayString(produit.uniteMesure), 1)
                                        ]),
                                        (_ctx.validateRowProduit(produit.qteBon))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, "La quantité retournée est obligatoire."))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (parseInt(_ctx.typeBon) === 2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                      _createElementVNode("div", _hoisted_58, [
                                        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                          _createTextVNode(" Reste à retourner "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_59, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            name: "resteAliv",
                                            readonly: "",
                                            "onUpdate:modelValue": ($event: any) => ((produit.resteAliv) = $event),
                                            class: _normalizeClass(_ctx.validateRowProduit(produit.resteAliv) ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'),
                                            placeholder: "Entrer la quantité"
                                          }, null, 10, _hoisted_60), [
                                            [_vModelText, produit.resteAliv]
                                          ]),
                                          _createElementVNode("span", _hoisted_61, _toDisplayString(produit.uniteMesure), 1)
                                        ]),
                                        (_ctx.validateRowProduit(produit.resteAliv))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, "Le reste à retourner est obligatoire."))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("button", {
                                    class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.removeRowMagasin(produitIndex))
                                  }, _cache[15] || (_cache[15] = [
                                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                                  ]), 8, _hoisted_64)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("div", _hoisted_66, [
                                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-md-7" }, [
                                    _createElementVNode("h5", { class: "fs-6 mx-1 text-white" }, "Les magasins")
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_67, [
                                    _createElementVNode("div", _hoisted_68, [
                                      _createElementVNode("button", {
                                        class: "btn btn-sm btn-success",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.addRowProduit(produitIndex))
                                      }, _cache[16] || (_cache[16] = [
                                        _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                                        _createTextVNode("Ajouter un magasin ")
                                      ]), 8, _hoisted_69)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_70, [
                                  _createElementVNode("div", _hoisted_71, [
                                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-md-3" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                        _createTextVNode(" Magasin "),
                                        _createElementVNode("span", { class: "text-danger" }, "*")
                                      ])
                                    ], -1)),
                                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-md-3" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                        _createTextVNode(" Fiche Produit "),
                                        _createElementVNode("span", { class: "text-danger" }, "*")
                                      ])
                                    ], -1)),
                                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-md-2" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                        _createTextVNode(" Stock"),
                                        _createElementVNode("span", { class: "text-danger" }, "*")
                                      ])
                                    ], -1)),
                                    (parseInt(_ctx.typeBon) === 1 || parseInt(_ctx.typeBon) === 2)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, _cache[18] || (_cache[18] = [
                                          _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                            _createTextVNode(" Quantité à mettre en stock"),
                                            _createElementVNode("span", { class: "text-danger" }, "*")
                                          ], -1)
                                        ])))
                                      : _createCommentVNode("", true),
                                    (parseInt(_ctx.typeBon) === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, _cache[19] || (_cache[19] = [
                                          _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                            _createTextVNode(" Quantité à retirer du stock"),
                                            _createElementVNode("span", { class: "text-danger" }, "*")
                                          ], -1)
                                        ])))
                                      : _createCommentVNode("", true),
                                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-md-1" }, [
                                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Action ")
                                    ], -1)),
                                    _cache[24] || (_cache[24] = _createElementVNode("hr", { class: "mt-0" }, null, -1))
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(produit.mouvements, (mov, movIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "row gx-2 gy-0",
                                      key: movIndex
                                    }, [
                                      _createElementVNode("div", _hoisted_74, [
                                        _createElementVNode("div", _hoisted_75, [
                                          _createVNode(_component_Multiselect, {
                                            options: _ctx.magasinOptions,
                                            searchable: true,
                                            "track-by": "label",
                                            label: "label",
                                            modelValue: mov.magasin,
                                            "onUpdate:modelValue": ($event: any) => ((mov.magasin) = $event),
                                            onSelect: ($event: any) => (_ctx.selectMov(mov.magasin, mov, produitIndex, movIndex)),
                                            placeholder: "Sélectionner le magasin"
                                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"]),
                                          (_ctx.validateRowProduit(mov.magasin))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, " Le magasin est obligatoire. "))
                                            : _createCommentVNode("", true),
                                          (_ctx.validateDupliacatMag(mov.magasin, produitIndex))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, " Le magasin a été déja selectionné. "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_78, [
                                        _createElementVNode("div", _hoisted_79, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            readonly: "",
                                            "onUpdate:modelValue": ($event: any) => ((mov.fiche.numFiche) = $event),
                                            class: _normalizeClass(_ctx.validateRowProduit(mov.fiche.numFiche)
                                      ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                      : 'form-control shadow-none fs-md-15 text-black '),
                                            placeholder: ""
                                          }, null, 10, _hoisted_80), [
                                            [_vModelText, mov.fiche.numFiche]
                                          ]),
                                          (_ctx.validateRowProduit(mov.fiche.numFiche))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_81, " La fiche est obligatoire. "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_82, [
                                        _createElementVNode("div", _hoisted_83, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            readonly: "",
                                            "onUpdate:modelValue": ($event: any) => ((mov.fiche.stock) = $event),
                                            class: "form-control shadow-none fs-md-15 text-black"
                                          }, null, 8, _hoisted_84), [
                                            [_vModelText, mov.fiche.stock]
                                          ]),
                                          _createElementVNode("span", _hoisted_85, _toDisplayString(mov.fiche.libelleCod), 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_86, [
                                        _createElementVNode("div", _hoisted_87, [
                                          _createElementVNode("div", _hoisted_88, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              "onUpdate:modelValue": ($event: any) => ((mov.qte) = $event),
                                              class: _normalizeClass(_ctx.validateRowProduit(mov.qte)
                                        ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                        : 'form-control shadow-none fs-md-15 text-black '),
                                              placeholder: "Entrer la quantité",
                                              "aria-label": "Sizing example input",
                                              "aria-describedby": "inputGroup-sizing-sm"
                                            }, null, 10, _hoisted_89), [
                                              [_vModelText, mov.qte]
                                            ]),
                                            _createElementVNode("span", _hoisted_90, _toDisplayString(produit.uniteMesure), 1)
                                          ]),
                                          (_ctx.validateRowProduit(mov.qte))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_91, " La quantité est obligatoire. "))
                                            : _createCommentVNode("", true),
                                          (produit.qteEstSup)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_92, " Vous avez depassé la quantité restante. "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_93, [
                                        _createElementVNode("button", {
                                          class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.removeRowProduit(produitIndex, movIndex))
                                        }, _cache[25] || (_cache[25] = [
                                          _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                                        ]), 8, _hoisted_94)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ], 10, _hoisted_20)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                (_ctx.produits.length > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-success me-3",
                      type: "submit",
                      disabled: _ctx.isDisable
                    }, " Ajouter un mouvement ", 8, _hoisted_97))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  to: "/inventaires/liste-mouvements",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}